"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.otherSurgicalInterventionTypeMessages = exports.hasDiseaseMessages = exports.OtherSurgicalInterventionType = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_OTHER_SURGICAL_INTERVENTION"] = "has_other_surgical_intervention";
    HasDisease["NO_UNKNOWN_OTHER_SURGICAL_INTERVENTION"] = "no_unknown_other_surgical_intervention";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var OtherSurgicalInterventionType;
(function (OtherSurgicalInterventionType) {
    OtherSurgicalInterventionType["PARATHYREOIDECTOMIA_TOTALIS"] = "parathyreoidectomia_totalis";
    OtherSurgicalInterventionType["PARATHYREOIDECTOMIA_PARTIALIS"] = "parathyreoidectomia_partialis";
    OtherSurgicalInterventionType["THYREOIDECTOMIA_TOTALIS"] = "thyreoidectomia_totalis";
    OtherSurgicalInterventionType["THYREOIDECTOMIA_PARTIALIS"] = "thyreoidectomia_partialis";
    OtherSurgicalInterventionType["APPENDECTOMIA"] = "appendectomia";
    OtherSurgicalInterventionType["TONSILLECTOMIA"] = "tonsillectomia";
    OtherSurgicalInterventionType["ADENOTOMIA"] = "adenotomia";
    OtherSurgicalInterventionType["CHOLECYSTECTOMIA_LC"] = "cholecystectomia_LC";
    OtherSurgicalInterventionType["HERNOPLASTICA_PAR_ABDOMINALIS"] = "hernoplastica_par_abdominalis";
    OtherSurgicalInterventionType["HERNIOPLASTICA_INGUINALIS_LS"] = "hernioplastica_inguinalis_ls";
    OtherSurgicalInterventionType["HERNIOPLASTICA_INGUINALIS_LD"] = "hernioplastica_inguinalis_ld";
    OtherSurgicalInterventionType["TURP"] = "turp";
    OtherSurgicalInterventionType["OTHER_SURGICAL_INTERVENTION_OTHER"] = "other_surgical_intervention_other";
})(OtherSurgicalInterventionType || (exports.OtherSurgicalInterventionType = OtherSurgicalInterventionType = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_OTHER_SURGICAL_INTERVENTION]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.hasDisease.HAS_OTHER_SURGICAL_INTERVENTION",
        defaultMessage: "Diagnosztizált egyéb sebészeti beavatkozás"
    },
    [HasDisease.NO_UNKNOWN_OTHER_SURGICAL_INTERVENTION]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.hasDisease.NO_UNKNOWN_OTHER_SURGICAL_INTERVENTION",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.otherSurgicalInterventionTypeMessages = {
    [OtherSurgicalInterventionType.PARATHYREOIDECTOMIA_TOTALIS]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.PARATHYREOIDECTOMIA_TOTALIS",
        defaultMessage: "Parathyreoidectomia totalis"
    },
    [OtherSurgicalInterventionType.PARATHYREOIDECTOMIA_PARTIALIS]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.PARATHYREOIDECTOMIA_PARTIALIS",
        defaultMessage: "Parathyreoidectomia partialis"
    },
    [OtherSurgicalInterventionType.THYREOIDECTOMIA_TOTALIS]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.THYREOIDECTOMIA_TOTALIS",
        defaultMessage: "Thyreoidectomia totalis"
    },
    [OtherSurgicalInterventionType.THYREOIDECTOMIA_PARTIALIS]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.THYREOIDECTOMIA_PARTIALIS",
        defaultMessage: "Thyreoidectomia partialis"
    },
    [OtherSurgicalInterventionType.APPENDECTOMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.APPENDECTOMIA",
        defaultMessage: "Appendectomia"
    },
    [OtherSurgicalInterventionType.TONSILLECTOMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.TONSILLECTOMIA",
        defaultMessage: "Tonsillectomia"
    },
    [OtherSurgicalInterventionType.ADENOTOMIA]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.ADENOTOMIA",
        defaultMessage: "Adenotomia"
    },
    [OtherSurgicalInterventionType.CHOLECYSTECTOMIA_LC]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.CHOLECYSTECTOMIA_LC",
        defaultMessage: "Cholecystectomia / LC"
    },
    [OtherSurgicalInterventionType.HERNOPLASTICA_PAR_ABDOMINALIS]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.HERNOPLASTICA_PAR_ABDOMINALIS",
        defaultMessage: "Hernioplastica par abdominalis"
    },
    [OtherSurgicalInterventionType.HERNIOPLASTICA_INGUINALIS_LS]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.HERNIOPLASTICA_INGUINALIS_LS",
        defaultMessage: "Hernioplastica inguinalis ls"
    },
    [OtherSurgicalInterventionType.HERNIOPLASTICA_INGUINALIS_LD]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.HERNIOPLASTICA_INGUINALIS_LD",
        defaultMessage: "Hernioplastica inguinalis ld"
    },
    [OtherSurgicalInterventionType.TURP]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.TURP",
        defaultMessage: "TURP"
    },
    [OtherSurgicalInterventionType.OTHER_SURGICAL_INTERVENTION_OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.otherSurgicalIntervention.otherSurgicalInterventionType.OTHER_SURGICAL_INTERVENTION_OTHER",
        defaultMessage: "Egyéb sebészeti beavatkozás"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_OTHER_SURGICAL_INTERVENTION).interpretation({ vocab: "ktx", code: "has_other_surgical_intervention" }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_OTHER_SURGICAL_INTERVENTION)
        .interpretation({
        vocab: "ktx",
        code: "no_unknown_other_surgical_intervention"
    })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" })
]).interpretation({
    vocab: "ktx",
    code: "has_other_surgical_intervention_choice"
});
const otherSurgicalInterventionType = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.PARATHYREOIDECTOMIA_TOTALIS)
        .interpretation({ vocab: "ktx", code: "parathyreoidectomia_totalis" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.PARATHYREOIDECTOMIA_PARTIALIS)
        .interpretation({ vocab: "ktx", code: "parathyreoidectomia_partialis" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.THYREOIDECTOMIA_TOTALIS)
        .interpretation({ vocab: "ktx", code: "thyreoidectomia_totalis" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.THYREOIDECTOMIA_PARTIALIS)
        .interpretation({ vocab: "ktx", code: "thyreoidectomia_partialis" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.APPENDECTOMIA)
        .interpretation({ vocab: "ktx", code: "appendectomia" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.TONSILLECTOMIA)
        .interpretation({ vocab: "ktx", code: "tonsillectomia" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.ADENOTOMIA)
        .interpretation({ vocab: "ktx", code: "adenotomia" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.CHOLECYSTECTOMIA_LC)
        .interpretation({ vocab: "ktx", code: "cholecystectomia_LC" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.HERNOPLASTICA_PAR_ABDOMINALIS)
        .interpretation({ vocab: "ktx", code: "hernoplastica_par_abdominalis" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.HERNIOPLASTICA_INGUINALIS_LS)
        .interpretation({ vocab: "ktx", code: "hernioplastica_inguinalis_ls" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.HERNIOPLASTICA_INGUINALIS_LD)
        .interpretation({ vocab: "ktx", code: "hernioplastica_inguinalis_ld" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.TURP)
        .interpretation({ vocab: "ktx", code: "turp" })
        .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }),
    schema_1.Schema.multiChoiceItem(OtherSurgicalInterventionType.OTHER_SURGICAL_INTERVENTION_OTHER)
]);
const otherSurgicalInterventionTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../otherSurgicalInterventionType}) && ({../otherSurgicalInterventionType}).includes("other_surgical_intervention_other")`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({
    vocab: "ktx",
    code: "other_surgical_intervention_other"
})
    .tag({ vocab: "ktx", code: "other_surgical_intervention_type" }));
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_other_surgical_intervention"`), schema_1.Schema.object().default({}).sealed(true).properties({
    otherSurgicalInterventionType,
    otherSurgicalInterventionTypeOther
}));
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases, comment })
    .interpretation({ vocab: "ktx", code: "other_surgical_intervention" });
